import { ReactNode, HTMLProps } from "react";
import "./styles/Button.scss";
import Loader from "../Loader/Loader";
type Style =
    | "stealth"
    | "primary"
    | "secondary"
    | "danger"
    | "remove"
    | "muted-danger"
    | "muted";

interface IProps extends HTMLProps<HTMLButtonElement> {
    preset: Style;
    type?: "button" | "submit" | "reset" | undefined;
    children: ReactNode;
    fn?: (e?: any) => void;
    isLoading?: boolean | undefined;
    value?: string | undefined;
}

const Button = ({
    preset = "primary",
    type = "button",
    children,
    fn,
    isLoading = false,
    value,
    ...rest
}: IProps) => {
    const { className, ...cleanedProps } = rest;
    const generateButton = () => {
        if (typeof fn === "function") {
            return (
                <button
                    disabled={isLoading}
                    className={`button button--${preset} ${className}`}
                    type={type}
                    onClick={fn}
                    name={value && "_action"}
                    value={value}
                    {...cleanedProps}
                >
                    {isLoading ? <Loader /> : children}
                </button>
            );
        } else {
            return (
                <button
                    disabled={isLoading}
                    className={`button button--${preset} ${className}`}
                    type={type}
                    name={value && "_action"}
                    value={value}
                >
                    {isLoading ? <Loader /> : children}
                </button>
            );
        }
    };

    return generateButton();
};
export default Button;
